import { gql } from '@src/lib/gql'

export const INBOX_DIRECT_ADVISOR = gql`
  query InboxDirectAdvisor($userId: String!) {
    userById(userId: $userId) {
      id
      userId
      fullName
      displayName
      pictureUrl
    }
  }
`
